export { versionNotifier } from './version-notifier.js';
